export default __webpack_public_path__ + "static/404-4-50adbcbefbaabbaaac84104195586ca9.jpg";